//algolia full text search
import algoliaSearch from 'algoliasearch';

var editClient = algoliaSearch('OPBAWRWYO4', '1ae25bb072cefd6cce2b5d17c01f0afd');
var productIndex = editClient.initIndex('Products');

function Product(id, isVisible, sku, name, description, categoryID, listPrice, photo, thumbnail) {
    this.id = id;
    this.sku = sku;
    this.name = name;
    this.description = description;
    this.categoryID = categoryID;
    this.listPrice = listPrice;
    this.photo = photo;
    this.thumbnail = thumbnail;
    this.isVisible = isVisible;
    this.attachments = [];
}

export const applySettings = () => {
    productIndex.setSettings({
        distinct: 1,
        attributeForDistinct: 'id',
        attributesForFaceting: ['filterOnly(isVisible)','filterOnly(categoryID)']
      });
}

export const deleteProduct = (product) => {
    
    productIndex.deleteObject(product.id, function(err, content) {
        if (err) throw err;    
    });
}

export const upsertProduct = (product) => {

    var p = new Product(product.id, product.IsVisible, product.sku, product.ProductName, product.BriefDescription, product.CategoryID, product.ListPrice);
    
    console.log('p');
    console.log(p);

    if(product.Photos) {
        if(product.Photos.length > 0) {
            for(var i = 0; i < product.Photos.length; i++) {
                if(product.Photos[i].isCover) {
                    p.photo = product.Photos[i].URL;
                }
                if (product.Photos[i].isThumb) {
                    p.thumbnail = product.Photos[i].URL;
                }
            }
        }
    }

    if(product.Attachments) {
        p.attachments = product.Attachments;
    } else {
        p.attachments = [];
    }

    if(product.Content) {
        p.Content = product.Content;
    }

    p.objectID = product.id;
    productIndex.addObject(p, function(err, content) {
        if(err) console.log('algolia save error');
        if (err) throw err;
        
    });
}

export const searchProducts = (query, category) => {

    return new Promise(function(resolve, reject) {
        
        var filter = "categoryID:" + category 

    /*      
        filter = filter + " AND "        
        filter = filter + "isVisible:true"
    */

        productIndex.search({query: query, filters: filter, hitsPerPage: 600}).then(results => {
            
            var objs = [];
            
            for(var i = 0; i < results.hits.length; i++) {
                var obj = results.hits[i];
                objs.push(obj);
            }

            resolve(objs);
        });
    });
}

export const getProductsByName = (name) => {

    return new Promise(function(resolve, reject) {
        
        productIndex.search({query: name, restrictSearchableAttributes: ['name']}).then(result => {
            
            console.log("result.hits");
            console.log(result.hits);

            var objs = [];
            
            for(var i = 0; i < result.hits.length; i++) {
                var obj = result.hits[i];
                objs.push(obj);
            }

            resolve(objs);
        });
    });
}



// WEBPACK FOOTER //
// ./src/assets/algolia/algolia.js